function hasBalancedBraces(text) {
    let depth = 0;

    for (let index = 0; index < text.length; index += 1) {
        const char = text[index];
        const previous = text[index - 1];

        if (char === "{" && previous !== "\\") {
            depth += 1;
            continue;
        }

        if (char === "}" && previous !== "\\") {
            depth -= 1;
            if (depth < 0) {
                return false;
            }
        }
    }

    return depth === 0;
}

function extractEnvironmentTokens(text) {
    const tokens = [];
    const pattern = /\\(begin|end)\{([^}]+)\}/g;
    let match = null;

    while ((match = pattern.exec(text))) {
        tokens.push({
            type: match[1],
            name: match[2],
        });
    }

    return tokens;
}

function hasBalancedEnvironments(text) {
    const stack = [];
    const tokens = extractEnvironmentTokens(text);

    for (const token of tokens) {
        if (token.type === "begin") {
            stack.push(token.name);
            continue;
        }

        const top = stack[stack.length - 1];
        if (top !== token.name) {
            return false;
        }
        stack.pop();
    }

    return stack.length === 0;
}

export function getBlockingAIEditError({ originalText, replacementText }) {
    const checks = [
        {
            name: "중괄호",
            originalOk: hasBalancedBraces(originalText),
            replacementOk: hasBalancedBraces(replacementText),
            message: "반영 결과에 중괄호 불균형이 있어 적용할 수 없습니다.",
        },
        {
            name: "LaTeX 환경",
            originalOk: hasBalancedEnvironments(originalText),
            replacementOk: hasBalancedEnvironments(replacementText),
            message: "반영 결과에 \\begin/\\end 환경 불균형이 있어 적용할 수 없습니다.",
        },
    ];

    for (const check of checks) {
        if (check.originalOk && !check.replacementOk) {
            return check.message;
        }
    }

    return "";
}
